var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.4629L14.0273 0.435612C14.179 0.283946 14.3656 0.206793 14.5873 0.204154C14.809 0.201515 14.9957 0.276029 15.1475 0.427696C15.2992 0.579362 15.375 0.766029 15.375 0.987696C15.375 1.20936 15.2992 1.3961 15.1475 1.5479L8.94229 7.76103C8.80549 7.89769 8.6575 7.9954 8.49833 8.05415C8.33917 8.11304 8.17306 8.14249 8 8.14249C7.82694 8.14249 7.66083 8.11304 7.50167 8.05415C7.3425 7.9954 7.19451 7.89769 7.05771 7.76103L0.852499 1.55582C0.700832 1.40415 0.62368 1.21617 0.621041 0.991861C0.618402 0.767417 0.692916 0.579362 0.844583 0.427695C0.996249 0.276028 1.18292 0.200195 1.40458 0.200195C1.62625 0.200195 1.81299 0.276028 1.96479 0.427695L8 6.4629Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowIcon);
export default __webpack_public_path__ + "static/media/up-arrow-icon.f40ce816790f07cb7568dec5fb467001.svg";
export { ForwardRef as ReactComponent };